import moment from 'moment-timezone';

import { WsSalesSolutionItem, WsSalesSolutionAction, WsSalesSolutionMetric } from '../core';

import { getValue } from '../helpers/item-helpers';

import { getHoursPerDay } from './sales-timeline';




const cssBackgroundColors = {

  // Governance #26272B
  '01H548HM2HA89VQTVKVCDJ2C3R': {
    1: '#e8e9eb',
    2: '#d1d2d7',
    3: '#afb1b9',
    4: '#828590'
  },

  // Core
  '01H4GTG96RG0D54NABN15GTFTB': {
    1: '#E2F0D9',
    2: '#C5E0B4',
    3: '#A9D18E',
    4: '#548235'
  },

  // Security
  '01H4GTG96R72GBPXJS0AA0VQN4': {
    1: '#DAE3F3',
    2: '#B4C7E7',
    3: '#2F5597',
    4: '#203390'
  },

  // Virtualization
  '01H4GTG96RDX8QTVHM3JE5JFTQ': {
    1: '#f0dbf9',
    2: '#e0b2f6',
    3: '#9b4ebe',
    4: '#6A0797'
  },

  // AI #FF5800
  '01H548KF2HR2D5MND0E01WRE09': {
    1: '#ffeee5',
    2: '#ffd5bf', // 75
    3: '#ffab80', // 50
    4: '#ff8a4d'
  },

  // Productivity
  '01H7YP9ABD1VPEPS42GQF10W87': {
    1: '#e8e9eb',
    2: '#d1d2d7',
    3: '#afb1b9',
    4: '#828590'
  },

  // Manage & Envolve
  '01H4GTG96RDZTAHKDXWN1JYM2F': {
    1: '#FFCCCC',
    2: '#FF9999',
    3: '#f54747',
    4: '#CC0000'
  },
};

const getAreaCssBackgroundColor = (areaId: string | undefined, level: number) => {
  if (areaId && cssBackgroundColors[areaId] && cssBackgroundColors[areaId][level]) {
    return cssBackgroundColors[areaId][level];
  } else {
    return 'transparent';
  }
};

const getActionCssBackgroundColor = (level: number) => {
  if (level === 1) {
    return '#f7f7f7';
  } else if (level === 2) {
    return '#f7f7f7';
  } else if (level === 3) {
    return '#f7f7f7';
  } else {
    return 'transparent';
  }
};




const cssColors = {

  // Governance
  '01H548HM2HA89VQTVKVCDJ2C3R': {
    1: '#26272B',
    2: '#26272B',
    3: '#26272B',
    4: '#e8e9eb'
  },

  '01H4GTG96RG0D54NABN15GTFTB': {
    1: '#264815',
    2: '#264815',
    3: '#264815',
    4: '#E2F0D9'
  },
  '01H4GTG96R72GBPXJS0AA0VQN4': {
    1: '#203390',
    2: '#203390',
    3: '#e5edfc',
    4: '#e5edfc'
  },

  // Virtualization
  '01H4GTG96RDX8QTVHM3JE5JFTQ': {
    1: '#6A0797',
    2: '#6A0797',
    3: '#f6e8fc',
    4: '#f6e8fc'
  },

  // AI
  '01H548KF2HR2D5MND0E01WRE09': {
    1: '#FF5800',
    2: '#FF5800',
    3: '#ffffff',
    4: '#ffffff'
  },

  // Productivity
  '01H7YP9ABD1VPEPS42GQF10W87': {
    1: '#26272B',
    2: '#26272B',
    3: '#26272B',
    4: '#e8e9eb'
  },

  // Manage & Envolve
  '01H4GTG96RDZTAHKDXWN1JYM2F': {
    1: '#960000',
    2: '#960000',
    3: '#ffe4e4',
    4: '#ffe4e4'
  },
};

const getAreaCssColor = (areaId: string | undefined, level: number) => {
  if (areaId && cssColors[areaId] && cssColors[areaId][level]) {
    return cssColors[areaId][level];
  } else {
    return '#ffffff';
  }
};




const getCapabilityEffort = (item: WsSalesSolutionItem, complexity: number, options: { includeChildCapabilities: boolean }) => {

  const includeChildCapabilities = getValue(options.includeChildCapabilities, false);

  let effort = 0;  


  // actions

  if (item.selected) {

    if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {

      item.actions.forEach((action) => {
        effort = effort + getActionEffort(action, { includeChildActions: true });
      });
    }
  }


  // items

  if (includeChildCapabilities) {

    if (item.items && Array.isArray(item.items) && item.items.length > 0) {

      item.items.forEach((i) => {

        // set complexity to 1 for recursive function calls
        effort = effort + getCapabilityEffort(i, 1, options);
      });
    }
  }


  // return

  // if (complexity !== 1) {
  //   return value * complexity;
  // } else {
  //   return value;
  // }

  return effort;
};




const getActionEffort = (action: WsSalesSolutionAction, options: { includeChildActions: boolean }) => {

  const includeChildActions = getValue(options.includeChildActions, false);

  let effort = 0;


  // actions

  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) { 

    // process children

    if (includeChildActions) {

      action.actions.forEach((a: WsSalesSolutionAction) => {
        effort = effort + getActionEffort(a, options);
      });
    }


  } else {

    // calculate efforts

    if (action.selected) {

      if (action.metrics && Array.isArray(action.metrics) && action.metrics.length > 0) {
        // action with metrics

        action.metrics.forEach((metric: WsSalesSolutionMetric) => {
          effort = effort + (metric.effort * metric.value);
        });

      } else {
        // action has no metrics
        effort = effort + (action.effort ? action.effort : 0);
      }
    }
  }


  // let effort = 0;

  // if (filterSelectedActions) {

  //   if (action.selected) {
  //     if (action.metrics && Array.isArray(action.metrics) && action.metrics.length > 0) {
  //       action.metrics.forEach((metric) => {
  //         effort = effort + (metric.effort * metric.value);
  //       });
  //     } else {
  //       effort = action.effort ? action.effort : 0;
  //     }
  //   }

  // } else {

  //   if (action.metrics && Array.isArray(action.metrics) && action.metrics.length > 0) {
  //     action.metrics.forEach((metric) => {
  //       effort = effort + (metric.effort * metric.value);
  //     });
  //   } else {
  //     effort = action.effort ? action.effort : 0;
  //   }
  // }


  // return
  return effort;
};





const getCapabilityMaxEffort = (items: WsSalesSolutionItem[]) => {

  const efforts: number[] = [ 0 ];

  items.forEach((item) => {

    if (item.selected) {
      const effort = getCapabilityEffort(item, 1, { includeChildCapabilities: false });
      efforts.push(effort);
    }
  });

  return Math.max(...efforts);
};




export {
  getAreaCssColor,
  getAreaCssBackgroundColor,
  getActionCssBackgroundColor,
  getCapabilityMaxEffort,
  getCapabilityEffort,
  getActionEffort
};
